module.exports = __webpack_public_path__ + "static/img/restroom-icon.a36fff70.svg";